import LogsView from "@/components/logs/LogsView";

export default function Logs() {
  return <LogsView />;
}
